import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { workOrderAssignmentRecordQuery } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderAssignmentQuery";
import { ProDriverDetailCards } from "@/app/ProDrivers/Drivers/Components/ProDriverDetailCards";

export function AssignmentDriverDetailsTab({
  assignmentId,
}: {
  assignmentId: string;
}) {
  const { data } = useSuspenseGqlQuery(workOrderAssignmentRecordQuery, {
    id: assignmentId,
  });

  const proDriver = data.workOrderAssignment?.proDriver;

  if (!proDriver) {
    return null;
  }

  return <ProDriverDetailCards proDriver={proDriver} />;
}
